// @ts-nocheck
import React from "react"
import {FormSectionElements} from "../../entities/formTemplateDataType";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {dateComparisonList, elementSize, FR_SUFFIX, odsCallOutBoxs, SubmissionMethodList} from "../../entities/Constants";
import {InputTextarea} from "primereact/inputtextarea";
import {Editor} from "primereact/editor";
import Utils from "../../utilities/Utils";
import {Checkbox} from "primereact/checkbox";
import {Calendar} from "primereact/calendar";
import {Button} from 'primereact/button';
import { generateSectionIndex, getRootComponent } from "../../utilities/ElementUtils";

export interface Props {
    ele: FormSectionElements;
    dialogVisible?: boolean;
    isEng: boolean;
    callback;

}
export interface State {}

export class DialogBase<P, S> extends React.Component<P, S> {
   spacingOptions= [
            { label: '-spacing0', value: '-spacing0' },
            { label: '-spacing1', value: '-spacing1' },
            { label: '-spacing2', value: '-spacing2' },
            { label: '-spacing3', value: '-spacing3' },
            { label: '-spacing4', value: '-spacing4' },
            { label: '-spacing5', value: '-spacing5' },
            { label: '-spacing6', value: '-spacing6' },
            { label: '-spacing7', value: '-spacing7' },
            { label: '-spacing8', value: '-spacing8' },
            { label: '-spacing9', value: '-spacing9' },
            { label: '-spacing10', value: '-spacing10' },
            { label: '-spacing11', value: '-spacing11' },
            { label: '-spacing12', value: '-spacing12' },
            { label: 'spacing0', value: 'spacing0' },
            { label: 'spacing1', value: 'spacing1' },
            { label: 'spacing2', value: 'spacing2' },
            { label: 'spacing3', value: 'spacing3' },
            { label: 'spacing4', value: 'spacing4' },
            { label: 'spacing5', value: 'spacing5' },
            { label: 'spacing6', value: 'spacing6' },
            { label: 'spacing7', value: 'spacing7' },
            { label: 'spacing8', value: 'spacing8' },
            { label: 'spacing9', value: 'spacing9' },
            { label: 'spacing10', value: 'spacing10' },
            { label: 'spacing11', value: 'spacing11' },
            { label: 'spacing12', value: 'spacing12' }
        ]

    spacingOptionsWithNegative= [
            { label: '-spacing0', value: '-spacing0' },
            { label: '-spacing1', value: '-spacing1' },
            { label: '-spacing2', value: '-spacing2' },
            { label: '-spacing3', value: '-spacing3' },
            { label: '-spacing4', value: '-spacing4' },
            { label: '-spacing5', value: '-spacing5' },
            { label: '-spacing6', value: '-spacing6' },
            { label: '-spacing7', value: '-spacing7' },
            { label: '-spacing8', value: '-spacing8' },
            { label: '-spacing9', value: '-spacing9' },
            { label: '-spacing10', value: '-spacing10' },
            { label: '-spacing11', value: '-spacing11' },
            { label: '-spacing12', value: '-spacing12' },
            { label: 'spacing0', value: 'spacing0' },
            { label: 'spacing1', value: 'spacing1' },
            { label: 'spacing2', value: 'spacing2' },
            { label: 'spacing3', value: 'spacing3' },
            { label: 'spacing4', value: 'spacing4' },
            { label: 'spacing5', value: 'spacing5' },
            { label: 'spacing6', value: 'spacing6' },
            { label: 'spacing7', value: 'spacing7' },
            { label: 'spacing8', value: 'spacing8' },
            { label: 'spacing9', value: 'spacing9' },
            { label: 'spacing10', value: 'spacing10' },
            { label: 'spacing11', value: 'spacing11' },
            { label: 'spacing12', value: 'spacing12' }
        ]
    
    buttonPositionOptions = [
        { label: "Left", value: "left" },
        { label: "Center", value: "center" },
        { label: "Right", value: "right" }
    ];
    
    uploadedFileDisplayOptions = [
        { label: "Original", value: "original" },
        { label: "Legacy", value: "legacy" },
        { label: "New", value: "new" }
    ];

    constructor(props: P) {
        super(props);
    }

    scriptHtml = () => {
        return (
            <>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Script</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <InputTextarea className="ontario-input" value={this.props.ele.Script} onChange={(e) => {this.props.ele.Script = e.target.value; this.props.callback();}}></InputTextarea>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Event Script</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <InputTextarea className="ontario-input" value={this.props.ele.EventScript} onChange={(e) => {this.props.ele.EventScript = e.target.value; this.props.callback();}}></InputTextarea>
                    </div>
                </div>
            </>
        )
    }
    stepperScriptHtml = () => {
        return (
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>Stepper Script</div>
                        <div style={{ width: '60%'}}>            
                        {/* @ts-ignore */}          
                        <InputTextarea className="ontario-input"  value={this.props.ele.StepperScript} 
                           onChange={(e) => {
                            {/* @ts-ignore */}
                            this.props.ele.StepperScript = e.target.value;
                            {/* @ts-ignore */}
                            this.props.callback();
                        }}></InputTextarea></div>
                    </div>
        )
    }
    initScriptHtml = () => {
        return (
            <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                            <div style={{ width: '25%' }}>Init Script</div>
                            <div style={{ width: '60%'}}>            
                                {/* @ts-ignore */}      
                                <InputTextarea className="ontario-input" value={this.props.ele.InitScript} 
                                onChange={(e) => {
                                    {/* @ts-ignore */}
                                    this.props.ele.InitScript = e.target.value;
                                    {/* @ts-ignore */}
                                    this.props.callback();
                                }}></InputTextarea></div>
                        </div>
            )
    }

    regexHtml = () => {
        return (
                
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Regular Expression</div>
                    {/* @ts-ignore */}
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.ele.RegularExpression} onChange={(e) => {this.props.ele.RegularExpression = e.target.value;  this.props.callback();
                    }}></InputText></div>
                </div>
        )
    }

    questionHintHtml = () => {
        // @ts-ignore
        const { ele, isEng, callback } = this.props;
        const useRaw = !!ele.useRawHint;

        const updateValues = (nextValue: string) => {
            // @ts-ignore
            if (isEng) {
                // @ts-ignore
                if (Utils.willDefaultFR(ele.Hint, ele.HintFR)) {
                    // @ts-ignore
                    ele.HintFR = Utils.isNullOrEmpty(nextValue) ? '' : nextValue + FR_SUFFIX;
                }
                // @ts-ignore
                ele.Hint = nextValue;
            } else {
                // @ts-ignore
                ele.HintFR = nextValue;
            }

            // @ts-ignore
            callback();
        };

        const handleEditorChange = (e: any) => {
            const value = e?.htmlValue ?? '';
            updateValues(value);
        };

        const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
            const value = e.target.value ?? '';
            updateValues(value);
        };

        const toggleMode = () => {
            // @ts-ignore
            ele.useRawHint = !useRaw;
            // @ts-ignore
            callback();
        };

        return (
            <div style={{ display: 'flex', marginTop: 10, marginBottom: 10 }}>
                <div style={{ width: '25%' }}>Question Hint</div>
                <div style={{ width: '60%' }}>
                    {useRaw ? (
                        // @ts-ignore
                        <InputTextarea
                            style={{ height: 'auto' }}
                            value={isEng ? ele.Hint : ele.HintFR}
                            onChange={handleTextareaChange}
                            className="ontario-input"
                        />
                    ) : (
                        // @ts-ignore
                        <Editor
                            key={'Hint' + ele.Sequence}
                            style={{ height: 'auto' }}
                            value={isEng ? ele.Hint : ele.HintFR}
                            onTextChange={handleEditorChange}
                        />
                    )}

                    <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
                        {/* @ts-ignore */}
                        <button
                            id={'useRawHint_' + ele.Sequence}
                            type="button"
                            onClick={toggleMode}
                        >
                            {useRaw ? 'Raw' : 'HTML'}
                    </button>
                    </div>
                </div>
            </div>
        );
    };

    tooTipHtml = () => {
        return (
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>Tool Tip</div>
                        {/* @ts-ignore */}
                        <div style={{ width: '60%' }}><InputText key={"TooltipENU" + this.props.ele.Sequence} className="ontario-input" value={this.props.isEng ? this.props.ele.TooltipENU : this.props.ele.TooltipFRA} onChange={(e) => {
                            {/* @ts-ignore */}
                            if (this.props.isEng){
                                {/* @ts-ignore */}
                                if(Utils.willDefaultFR(this.props.ele.TooltipENU,this.props.ele.TooltipFRA)){
                                    {/* @ts-ignore */}
                                    this.props.ele.TooltipFRA= Utils.isNullOrEmpty(e.target.value)? '':e.target.value+ FR_SUFFIX;
                                }
                                {/* @ts-ignore */}
                                this.props.ele.TooltipENU = e.target.value;
                            }else{
                                {/* @ts-ignore */}
                                this.props.ele.TooltipFRA = e.target.value;
                            }
                            {/* @ts-ignore */}
                            this.props.callback();
                        }}></InputText></div>
                    </div>
        )
    }

    renderHighlightFieldErrorToggle = () => {
    return (
        <>
            <div style={{ display: "flex", margin: "10px 0" }}>
                <div style={{ width: "25%" }}>
                    <label htmlFor={`highlightFieldError_${this.props.ele.Sequence}`}>
                        Enable Highlight Field Error
                    </label>
                </div>

                <div style={{ width: "60%" }}>
                    <Checkbox
                        id={`highlightFieldErrorCheckbox_${this.props.ele.Sequence}`}
                        checked={this.props.ele.enableHighlightFieldError}
                        onChange={(e) => {
                            this.props.ele.enableHighlightFieldError = e.checked;
                            this.props.callback();
                        }}
                    />
                </div>
            </div>

            {this.props.ele.enableHighlightFieldError && (
                <div style={{ display: "flex", marginTop: "10px", marginLeft: "20px" }}>
                    <div style={{ width: "25%" }}>
                        <label>Show Live Error Above Label</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox
                            value={this.props.ele.showErrorAboveLabel}
                            onChange={(e) => {
                                this.props.ele.showErrorAboveLabel = e.checked;
                                this.props.callback();
                            }}
                            checked={this.props.ele.showErrorAboveLabel}
                                />
                            </div>
                        </div>
                    )}
                </>
            );
        }

    emptyErrorMessageHtml = () => {
        return (
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>Empty Error Message</div>
                        <div style={{ width: '60%' }}>
                            {/* @ts-ignore */}
                            <InputText key={"EmptyErrorMessage" + this.props.ele.Sequence} className="ontario-input" value={this.props.isEng ? this.props.ele.EmptyErrorMessage : this.props.ele.EmptyErrorMessageFRA}
                                onChange={(e) => {
                                    {/* @ts-ignore */}
                                    if (this.props.isEng){
                                        {/* @ts-ignore */}
                                        this.props.ele.EmptyErrorMessage = e.target.value;
                                    }else{
                                        {/* @ts-ignore */}
                                        this.props.ele.EmptyErrorMessageFRA = e.target.value;
                                    }    
                                    {/* @ts-ignore */}
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
        )
    }

    errorMessageHtml = () => {
        return (
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>Custom Error Message</div>
                        <div style={{ width: '60%' }}>
                            {/* @ts-ignore */}
                            <InputText key={"ErrorMessage" + this.props.ele.Sequence} className="ontario-input" value={this.props.isEng ? this.props.ele.ErrorMessage : this.props.ele.ErrorMessageFRA}
                                onChange={(e) => {
                                    {/* @ts-ignore */}
                                    if (this.props.isEng){
                                        {/* @ts-ignore */}
                                        this.props.ele.ErrorMessage = e.target.value;
                                    }else{
                                        {/* @ts-ignore */}
                                        this.props.ele.ErrorMessageFRA = e.target.value;
                                    }
                                    {/* @ts-ignore */}
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
        )
    }

    enableRichTextErrorMessage = () => {
        return (
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
    
                        <div style={{ width: '25%' }}>
                            {/* @ts-ignore */}
                            <label htmlFor={"enableRichText_" + this.props.ele.Sequence}>Enable Custom Rich Text Error</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            {/* @ts-ignore */}
                            <Checkbox value={this.props.ele.enableCustomRichTextErrorMessage} id={"checkBoxCustomRichText_" + this.props.ele.Sequence} checked={this.props.ele.enableCustomRichTextErrorMessage} 
                                onChange={(e) => { 
                                    {/* @ts-ignore */}
                                    this.props.ele.enableCustomRichTextErrorMessage = e.checked; 
                                    {/* @ts-ignore */}
                                    this.props.callback() 
                                    }} 
                                    />
                        </div>
                    </div>
        )

    }

    richTextErrorMessageHtml = () => {
        return (
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Custom Rich Text Error Message</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Editor key={"ErrorMessage" + this.props.ele.Sequence}  className="ontario-input" value={this.props.isEng ? this.props.ele.ErrorMessageRichText : this.props.ele.ErrorMessageRichTextFRA}
                            onTextChange={(e) => {
                                {/* @ts-ignore */}
                                if (this.props.isEng){
                                    {/* @ts-ignore */}
                                    this.props.ele.ErrorMessageRichText = e.htmlValue;
                                }else{
                                    {/* @ts-ignore */}
                                    this.props.ele.ErrorMessageRichTextFRA = e.htmlValue;
                                }
                                {/* @ts-ignore */}
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
        )
    }

    expectedValueHtml = () => {
        return (
            <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                <div style={{ width: '25%' }}>Expected values</div>
                <div style={{ width: '60%' }}>
                    {/* @ts-ignore */}
                    <Dropdown key={"ExpectedOption" + this.props.ele.Sequence} options={this.expectedValueOptions} optionLabel={this.props.isEng ? 'label' : 'labelFRA'} optionValue='val' value={this.props.ele.ListOfExpectedValues?.[0] ?? ''}
                        onChange={(e) => {
                            {/* @ts-ignore */ }
                            this.props.ele.ListOfExpectedValues = [e.target.value];
                            {/* @ts-ignore */ }
                            this.props.callback();
                        }}
                    />
                </div>
            </div>
        )
    }

    calloutBoxHtml = () => {
        // @ts-ignore
        const useRawCalloutBody = !!this.props.ele.useRawCalloutBoxBody;
        // @ts-ignore
        const calloutBodyValue = this.props.isEng? this.props.ele.callOutBoxBody: this.props.ele.callOutBoxBodyFRA;

        // @ts-ignore
        const updateCalloutBody = (nextValue: string) => {
            // @ts-ignore
        if (this.props.isEng) {
                // @ts-ignore
                if (Utils.willDefaultFR(this.props.ele.callOutBoxBody, this.props.ele.callOutBoxBodyFRA)) {
                    // @ts-ignore
                    this.props.ele.callOutBoxBodyFRA = Utils.isNullOrEmpty(nextValue) ? '' : nextValue + FR_SUFFIX;
                }
                // @ts-ignore
                this.props.ele.callOutBoxBody = nextValue;
            } else {
                // @ts-ignore
                this.props.ele.callOutBoxBodyFRA = nextValue;
            }
            // @ts-ignore
            this.props.callback();
        };

        return (
            <>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown className="ontario-dropdown-small" showClear options={odsCallOutBoxs} optionLabel='label' optionValue='val' value={this.props.ele.callOutBoxType} onChange={(e) => {
                            {/* @ts-ignore */}
                            this.props.ele.callOutBoxType = e.value;
                            {/* @ts-ignore */}
                            this.props.callback();
                        }}></Dropdown>
                    </div>
                </div>
                {/* @ts-ignore */}
                <div style={{ display: this.props.ele.callOutBoxType != null ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box Title</div>
                    {/* @ts-ignore */}
                    <div style={{ width: '60%' }}><InputText key={"callOutBoxTitle" + this.props.ele.Sequence} className="ontario-input"  value={this.props.isEng ? this.props.ele.callOutBoxTitle : this.props.ele.callOutBoxTitleFRA}
                        onChange={(e) => {
                            {/* @ts-ignore */}
                            if (this.props.isEng){
                                {/* @ts-ignore */}
                                if(Utils.willDefaultFR(this.props.ele.callOutBoxTitle,this.props.ele.callOutBoxTitleFRA)){
                                    {/* @ts-ignore */}
                                    this.props.ele.callOutBoxTitleFRA= Utils.isNullOrEmpty(e.target.value)? '':e.target.value+ FR_SUFFIX;
                                }
                                {/* @ts-ignore */}
                                this.props.ele.callOutBoxTitle = e.target.value;
                            }else{
                                {/* @ts-ignore */}
                                this.props.ele.callOutBoxTitleFRA = e.target.value;
                            }
                            {/* @ts-ignore */}
                            this.props.callback();
                        }}></InputText></div>
                </div>
                {/* @ts-ignore */}
                <div style={{ display: this.props.ele.callOutBoxType != null ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box Body Message</div>
                    <div style={{ width: '60%' }}>
                        {useRawCalloutBody ? (
                            <InputTextarea
                                className="ontario-input"
                                style={{ height: 'auto' }}
                                value={calloutBodyValue}
                                onChange={(e) => updateCalloutBody(e.target.value ?? '')}
                            />
                        ) : (
                            <Editor
                                className="ontario-input"
                                value={calloutBodyValue}
                                onTextChange={(e) => updateCalloutBody(e?.htmlValue ?? '')}
                            />
                        )}
                        <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 8 }}>    
                            <button id={'useRawCalloutBody_' + this.props.ele.Sequence}
                                type="button"
                                onClick={() => {
                                    this.props.ele.useRawCalloutBoxBody = !useRawCalloutBody;
                                    this.props.callback();
                                }}
                            >
                                {useRawCalloutBody ? 'Raw' : 'HTML'}
                            </button>
                        </div>
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Size</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown className="ontario-dropdown-small" showClear value={this.props.ele.callOutSize}
                                  options={elementSize}
                                  optionLabel='label'
                                  optionValue='val'
                                  onChange={(e) => {
                            {/* @ts-ignore */}
                            this.props.ele.callOutSize = e.value;
                            {/* @ts-ignore */}
                            this.props.callback();
                        }}></Dropdown>
                    </div>
                </div>
                {/* @ts-ignore */}
                {this.props.ele.callOutBoxType != null && (
                    <>
                        <div style={{ display: 'flex', marginTop: '10px', alignItems: 'center' }}>
                            <div style={{ width: '25%' }}>Fade Out</div>
                            <div style={{ width: '60%', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <Checkbox
                                    inputId={`callout_fadeout_cb_${this.props.ele.Sequence}`}
                                    checked={this.props.ele.FadeOut ?? false}
                                    onChange={(e) => {
                                        this.props.ele.FadeOut = e.checked;
                                        if (!e.checked) this.props.ele.FadeOutSeconds = 0;
                                        this.props.callback();
                                    }}
                                />
                                <label htmlFor={`callout_fadeout_cb_${this.props.ele.Sequence}`} style={{ cursor: 'pointer' }}>
                                    Enable fade out
                                </label>
                            </div>
                        </div>
                        {this.props.ele.FadeOut && (
                            <div style={{ display: 'flex', marginTop: '10px', alignItems: 'center' }}>
                                <div style={{ width: '25%' }}>Fade Out After (seconds)</div>
                                <div style={{ width: '60%' }}>
                                    <input
                                        type="number"
                                        min={0}
                                        step={1}
                                        className="ontario-input"
                                        style={{ width: '120px' }}
                                        value={this.props.ele.FadeOutSeconds ?? 0}
                                        onChange={(e) => {
                                            this.props.ele.FadeOutSeconds = Math.max(0, parseInt(e.target.value, 10) || 0);
                                            this.props.callback();
                                        }}
                                    />
                                    <span style={{ marginLeft: '0.5rem', color: '#666', fontSize: '0.875rem' }}>
                                        (0 = no fade out)
                                    </span>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </>

        )
    }

    hintExpansionTitleHtml = () => {
        return (
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>Hint Expansion Title</div>
                        <div style={{ width: '60%' }}>
                            {/* @ts-ignore */}
                            <InputText className="ontario-input" value={this.props.isEng ? this.props.ele.hintExpansionTitle: this.props.ele.hintExpansionTitleFRA}
                            onChange={(e) => {
                                {/* @ts-ignore */}
                                if (this.props.isEng) {
                                    {/* @ts-ignore */}
                                    if(Utils.willDefaultFR(this.props.ele.hintExpansionTitle,this.props.ele.hintExpansionTitleFRA)){
                                        {/* @ts-ignore */}
                                        this.props.ele.hintExpansionTitleFRA= Utils.isNullOrEmpty(e.target.value)? '':e.target.value + FR_SUFFIX;
                                    }
                                    {/* @ts-ignore */}
                                    this.props.ele.hintExpansionTitle = e.target.value;
                                }
                                else {
                                    {/* @ts-ignore */}
                                    this.props.ele.hintExpansionTitleFRA = e.target.value;
                                }
                                {/* @ts-ignore */}
                                this.props.callback();
                            }}></InputText></div>
                    </div>
        )
    }
    hintExpansionContentHtml = () => {
        return (
                    <div style={{ display: "flex", marginTop: '10px'}}>
                        <div style={{ width: '25%' }}>Hint Expanded Content</div>
                        <div style={{ width: '60%' , resize:'both', overflow:'auto'}} >
                            {/* @ts-ignore */}
                            <Editor  value={this.props.isEng ? this.props.ele.hintExpansionContent: this.props.ele.hintExpansionContentFRA}
                            onTextChange={(e) => {
                                {/* @ts-ignore */}
                                if (this.props.isEng) {
                                    {/* @ts-ignore */}
                                    if(Utils.willDefaultFR(this.props.ele.hintExpansionContent,this.props.ele.hintExpansionContentFRA)){
                                        {/* @ts-ignore */}
                                        this.props.ele.hintExpansionContentFRA= Utils.isNullOrEmpty(e.htmlValue)? '':e.htmlValue + FR_SUFFIX;
                                    }
                                    {/* @ts-ignore */}
                                    this.props.ele.hintExpansionContent = e.htmlValue;
                                }
                                else {
                                    {/* @ts-ignore */}
                                    this.props.ele.hintExpansionContentFRA = e.htmlValue;
                                }
                                {/* @ts-ignore */}
                                this.props.callback();
                            }}></Editor></div>
                    </div>
        )
    }

    hintExpansionBelowElementLabelHtml = () => {
        return (
                    <div style={{ display: "flex", marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            {/* @ts-ignore */}
                            <label htmlFor={"hintExpansionBelowElementLabel_" + this.props.ele.Sequence} role='tooltip' title={"Hint button above element instead of below options (only for radio button as of Jan2026)"}>Hint expansion below element label</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            {/* @ts-ignore */}
                            <Checkbox value={this.props.ele.hintExpansionBelowElementLabel} id={"hintExpansionBelowElementLabel_" + this.props.ele.Sequence} onChange={(e) => { this.props.ele.hintExpansionBelowElementLabel = e.checked; this.props.callback() }} checked={this.props.ele.hintExpansionBelowElementLabel} />
                        </div>
                    </div>

        )
    }
    maskSummaryHtml = () => {
        return (
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>
                            {/* @ts-ignore */}
                            <label htmlFor={"maskinsummary_" + this.props.ele.Sequence}>Mask in Summary</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            {/* @ts-ignore */}
                            <Checkbox value={this.props.ele.MaskInSummary} id={"maskinsummary_" + this.props.ele.Sequence} onChange={(e) => { this.props.ele.MaskInSummary = e.checked; this.props.callback() }} checked={this.props.ele.MaskInSummary} />
                        </div>
                    </div>

        )
    }

    excludeFromPayload = () => {
        return (
            <div style={{display: "flex", marginTop: '10px'}}>
                <div style={{width: '25%'}}>
                    {/* @ts-ignore */}
                    <label htmlFor={"show_optional_label_" + this.props.ele.Sequence}>Exclude from API Payload:</label>
                </div>
                <div style={{width: '60%'}}>
                    {/* @ts-ignore */}
                    <Checkbox id={"show_optional_label_" + this.props.ele.Sequence}  onChange={(e) => {this.props.ele.excludedFromPayload = e.checked;this.props.callback()}} checked={this.props.ele.excludedFromPayload ?? false} value={this.props.ele.excludedFromPayload ?? false}
                              title="When checked, this field will not be included in API payload data."
                    />
                </div>
            </div>
        )
    }

    sharableElement = () => {
       let elementListWithOptions = [{code:'', description:'Please select a field'}];
    
        {/* @ts-ignore */}
        let root = getRootComponent(this.props.ele);
        
        for (const form of root.ListOfFormSections) {
            for (const subForm of form.ListOfFormSubSections) {
                for (const ele of subForm.ListOfFormSectionElements) {
                    if(ele.sharable){
                        {/* @ts-ignore */}
                        elementListWithOptions.push({code:ele.LoadBindName??"", description:this.props.isEng?ele.ENUTitle:ele.FRATitle});
                    }

                }

            }
        }

        return (
            <div style={{display: "flex", marginTop: '10px'}}>
                <div style={{width: '25%'}}>
                    {/* @ts-ignore */}
                    <label htmlFor={"show_optional_label_" + this.props.ele.Sequence}>Sharing:</label>
                </div>
                <div style={{width: '10%'}}>
                    {/* @ts-ignore */}
                    <Checkbox id={"show_optional_label_" + this.props.ele.Sequence}  onChange={(e) => {this.props.ele.sharable = e.checked;this.props.callback()}} checked={this.props.ele.sharable ?? false} value={this.props.ele.sharable ?? false}
                              title="When checked, this element can be shared."
                    />
                </div>
                <div style={{ width: '20%' }}>Choose Sharing Field</div>
                <div style={{ width: '30%' }}>
                    {/* @ts-ignore */}
                    <Dropdown options={elementListWithOptions} style={{width:'100%'}}  className="ontario-dropdown-small"  optionLabel="description"  optionValue="code" value={this.props.ele.shareReferenceId??''}
                        onChange={(e) => {
                            {/* @ts-ignore */}
                            this.props.ele.shareReferenceId = e.value; this.props.callback()
                        }}></Dropdown></div>
            </div>
        )
    }

    
    InitialVisibility = () => {
        return (
            <div style={{ display: "flex", marginTop: '10px' }}>
                <div style={{ width: '25%' }}>
                      {/* @ts-ignore */}
                    <label htmlFor={"show_optional_label_" + this.props.ele.Sequence}>Invisible by Default:</label>
                </div>
                <div style={{ width: '60%' }}>
                      {/* @ts-ignore */}
                    <Checkbox id={"show_optional_label_" + this.props.ele.Sequence} checked={this.props.ele.InvisibleByDefault ?? false} value={this.props.ele.InvisibleByDefault ?? false} title="When checked, this field will be invisible by default." onChange={(e) => { this.props.ele.InvisibleByDefault = e.checked; this.props.callback();
                        }
                        }
                    />
                </div>
            </div>
        )
    }

    fieldOnTopHtml = () => {
        return (
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
    
                        <div style={{ width: '25%' }}>
                            {/* @ts-ignore */}
                            <label htmlFor={"maskinsummary_" + this.props.ele.Sequence}>Field must be on top?</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            {/* @ts-ignore */}
                            <Checkbox value={this.props.ele.FieldMustBeAtTop} id={"Fieldmustbeintop_" + this.props.ele.Sequence} checked={this.props.ele.FieldMustBeAtTop} 
                                onChange={(e) => { 
                                    {/* @ts-ignore */}
                                    this.props.ele.FieldMustBeAtTop = e.checked; 
                                    {/* @ts-ignore */}
                                    this.props.callback() 
                                    }} 
                                    />
                        </div>
                    </div>
        )
    }

    fieldSizeHtml = () => {
        return (
            <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                <div style={{ width: '25%' }}>
                    <label htmlFor={"field_size_" + this.props.ele.Sequence}>Field Size:</label>
                </div>
                <div style={{ width: '25%' }}>
                    {/* @ts-ignore */}
                    <InputText className="ontario-input" id={"field_size_" + this.props.ele.Sequence}
                        placeholder="e.g. 1rem"
                        value={this.props.ele.fieldSize ?? ''}
                        onChange={(e) => {
                            this.props.ele.fieldSize = e.target.value;
                            this.props.callback();
                        }}
                    />
                </div>
                <div style={{ width: '10%', textAlign: 'right', paddingRight: '5px' }}>
                    <label htmlFor={"field_hint_size_" + this.props.ele.Sequence}>Hint Size:</label>
                </div>
                <div style={{ width: '25%' }}>
                    {/* @ts-ignore */}
                    <InputText className="ontario-input" id={"field_hint_size_" + this.props.ele.Sequence}
                        placeholder="e.g. 1rem"
                        value={this.props.ele.fieldHintSize ?? ''}
                        onChange={(e) => {
                            this.props.ele.fieldHintSize = e.target.value;
                            this.props.callback();
                        }}
                    />
                </div>
            </div>
        )
    }

    listValuesApiHtml = () => {
        return (
            <>
            {/* @ts-ignore */}
            <div style={{ display: ["Dropdown","CheckboxGroup","CheckGroup","RadioButton", "SearchAutocomplete",  "SummaryList"].includes(this.props.ele.Datatype)? "flex":"none" , marginTop: '10px', marginBottom: '20px' }}>
                <div style={{ width: '25%' }}>
                    {/* @ts-ignore */}
                    <label htmlFor={"LovAPI" + this.props.ele.Sequence}>List of Values API</label>
                </div>
                <div style={{ width: '60%' }}>
                    {/* @ts-ignore */}
                    <InputText key={"LovAPI" + this.props.ele.Sequence} value={this.props.ele.LovAPI} className="ontario-input"  onChange={(e) => { this.props.ele.LovAPI = e.target.value; this.props.callback() }}
                    />
                </div>
            </div>
            </>
        )
    }

    searchAutoCompleteHtml = () => {
        return (
            <>
            {/* @ts-ignore */}
            <div style={{ display: ["SearchAutocomplete"].includes(this.props.ele.Datatype)? "flex":"none" , marginTop: '10px', marginBottom: '20px' }}>
                <div style={{ width: '25%' }}>
                    {/* @ts-ignore */}
                    <label htmlFor={"KeepUnmatchedInput_" + this.props.ele.Sequence}>Keep unmatched input</label>
                </div>
                <div style={{ width: '60%' }}>
                    {/* @ts-ignore */}
                    <Checkbox value={this.props.ele.keepUnmatchedInput} id={"KeepUnmatchedInput_" + this.props.ele.Sequence} checked={this.props.ele.keepUnmatchedInput} 
                        onChange={(e) => { 
                            {/* @ts-ignore */}
                            this.props.ele.keepUnmatchedInput = e.checked; 
                            {/* @ts-ignore */}
                            this.props.callback() 
                    }}/>
                </div>
            </div>
            </>
        )
    }

    updateBindingFieldHtml = () => {
        return (
            <>
                <div style={{display: "flex", marginTop: '10px', marginBottom: '10px'}}>
                    <div style={{width: '25%'}}>
                        {/* @ts-ignore */}
                        <label htmlFor={"UpdateField" + this.props.ele.Sequence}>Update Binding Field</label>
                    </div>
                    <div style={{width: '60%'}}>
                        {/* @ts-ignore */}
                        <InputText key={"UpdateField" + this.props.ele.Sequence} value={this.props.ele.UpdateField} className="ontario-input" onChange={(e) => {this.props.ele.UpdateField = e.target.value;this.props.callback()}}/>
                    </div>
                </div>
                <div style={{display: "flex", marginTop: '10px', marginBottom: '10px'}}>
                    <div style={{width: '25%'}}>
                        {/* @ts-ignore */}
                        <label htmlFor={"syncAllBindingField" + this.props.ele.Sequence}>Sync All Binding Fields</label>
                    </div>
                    <div style={{width: '60%'}}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.syncAllBindingField} id={"syncAllBindingField" + this.props.ele.Sequence} onChange={(e) => { this.props.ele.syncAllBindingField = e.checked; this.props.callback() }} checked={this.props.ele.syncAllBindingField} />
                    </div>
                </div>
            </>
        )
    }

    dateCompareDisplayHtml = () => {
        return (
            <>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <label style={{ width: '25%', alignItems: 'center' }}>Date Comparison</label>

                    {/* @ts-ignore */}
                    <Dropdown className="ontario-dropdown" options={dateComparisonList} optionLabel='label' optionValue='val' value={this.props.ele.ValidateCompareMethod} 
                        style={{ width: '29.5%', paddingRight: '3px', marginRight: '1%' }}
                        placeholder="Comparison"
                        onChange={(e) => {
                            {/* @ts-ignore */}
                            this.props.ele.ValidateCompareMethod = e.value;
                            {/* @ts-ignore */}
                            this.props.callback();
                        }}>
                    </Dropdown>
                    {/* @ts-ignore */}
                    <Dropdown className="ontario-dropdown" options={this.dateTypeFieldList} optionLabel='ENUTitle' optionValue='LoadBindName' value={this.props.ele.ValidateCompareField} 
                        style={{ width: '29.5%', paddingRight: '3px' }}
                        placeholder="Field"
                        onChange={(e) => {
                            {/* @ts-ignore */}
                            this.props.ele.ValidateCompareField = e.value;
                            {/* @ts-ignore */}
                            this.props.callback();
                        }}>
                    </Dropdown>
                </div>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <label style={{ width: '25%', alignItems: 'center' }}>Date Display Format</label>

                    {/* @ts-ignore */}
                    <InputText id={"dateDisplayFOrmat" + this.props.ele.Sequence} className="ontario-input" value={this.props.ele.DateDisplayFormat}
                        onChange={(e) => {
                            {/* @ts-ignore */}
                            this.props.ele.DateDisplayFormat = e.target.value;
                            {/* @ts-ignore */}
                            this.props.callback();
                        }}
                    />
                </div>
            </>
        )
    }

    dateLimitRangeHtml = () => {
        {/* @ts-ignore */}
        const min = this.props.ele.MinDate ? new Date(this.props.ele.MinDate) : null;
        {/* @ts-ignore */}
        const max = this.props.ele.MaxDate ? new Date(this.props.ele.MaxDate) : null;

        return (
            <div 
                style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    gap: '10px', 
                    marginTop: '10px', 
                    marginBottom: '10px'
                }}
            >

                {/* min date picker */}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <label style={{ width: '25%' }}>Minimum Date</label>
                    {/* @ts-ignore */}
                    <Calendar maxDate={max ? max : undefined}
                        showIcon
                        value={min}
                        dateFormat='mm/dd/yy'
                        monthNavigator
                        yearNavigator
                        yearRange='1900:2100'
                        style={{ width: '60%' }}
                        onChange={(e) => {
                            const val = e.value as Date;
                            {/* @ts-ignore */}
                            this.props.ele.MinDate = val ? val.toISOString() : null;
                            {/* @ts-ignore */}
                            this.props.callback();
                        }}
                    />
                </div>

                {/* max date picker */}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <label style={{ width: '25%' }}>Maximum Date</label>
                    {/* @ts-ignore */}
                    <Calendar minDate={min ? min : undefined}
                        showIcon
                        value={max}
                        dateFormat='mm/dd/yy'
                        style={{ width: '60%' }}
                        monthNavigator
                        yearNavigator
                        yearRange='1900:2100'
                        onChange={(e) => {
                            const val = e.value as Date;
                            {/* @ts-ignore */}
                            this.props.ele.MaxDate = val ? val.toISOString() : null;
                            {/* @ts-ignore */}
                            this.props.callback();
                        }}
                    />
                </div>
            </div>
        );
    };
      
    indentHtml = () => (
        <>        
            <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                <div style={{ width: '25%' }}>
                    {/* @ts-ignore */}
                    <label htmlFor={"indent" + this.props.ele.Sequence}>Indent Size: </label>
                </div>
                <div style={{ width: '60%' }}>
                    {/* @ts-ignore */}
                    <InputText key={"indent" + this.props.ele.Sequence} value={this.props.ele.indents} className="ontario-input" onChange={(e) => { const inputVal = parseInt(e.target.value); this.props.ele.indents = isNaN(inputVal) ? this.props.ele.indents ?? 0 : inputVal; this.props.callback(); }} />
                </div>                
            </div>
            <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                <div style={{ width: '25%' }}>
                    {/* @ts-ignore */}
                    <label htmlFor={"TopMarginSize" + this.props.ele.Sequence}>Top Margin Size: </label>
                </div>
                <div style={{ width: '60%' }}>
                    {/* @ts-ignore */}
                    <Dropdown value={this.props.ele.MarginTop} options={this.spacingOptions}
                        optionLabel='label'
                        optionValue='value'
                        style={{ width: '29.5%', paddingRight: '3px' }}
                        onChange={(e) => {
                            {/* @ts-ignore */ }
                            this.props.ele.MarginTop = e.value;
                            {/* @ts-ignore */ }
                            this.props.callback();
                        }}>
                    </Dropdown>
                </div>
            </div>
            <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                <div style={{ width: '25%' }}>
                    {/* @ts-ignore */}
                    <label htmlFor={"BottomMarginSize" + this.props.ele.Sequence}>Bottom Margin Size: </label>
                </div>
                <div style={{ width: '60%' }}>
                    {/* @ts-ignore */}
                    <Dropdown value={this.props.ele.MarginBottom} options={this.spacingOptionsWithNegative}
                        optionLabel='label'
                        optionValue='value'
                        style={{ width: '29.5%', paddingRight: '3px' }}
                        onChange={(e) => {
                            {/* @ts-ignore */ }
                            this.props.ele.MarginBottom = e.value;
                            {/* @ts-ignore */ }
                            this.props.callback();
                        }}>
                    </Dropdown>
                </div>
            </div>
            <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                <div style={{ width: '25%' }}>
                    {/* @ts-ignore */}
                    <label htmlFor={"WidthSize" + this.props.ele.Sequence}>Width Size: </label>
                </div>
                <div style={{ width: '60%' }}>
                    {/* @ts-ignore */}
                    <InputText key={"WidthSize" + this.props.ele.Sequence} value={this.props.ele.colWidth} className="ontario-input" onChange={(e) => { this.props.ele.colWidth = e.target.value; this.props.callback(); }} />
                </div>
            </div>

            <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                <div style={{ width: '25%' }}>
                    {/* @ts-ignore */}
                    <label htmlFor={"NoLabel" + this.props.ele.Sequence}>No Label</label>
                </div>
                <div style={{ width: '60%' }}>
                    {/* @ts-ignore */}
                    <Checkbox value={this.props.ele.NoLabel} id={"NoLabel" + this.props.ele.Sequence} onChange={(e) => { this.props.ele.NoLabel = e.checked; this.props.callback() }} checked={this.props.ele.NoLabel} />
                </div>
            </div>
            <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                <div style={{ width: '25%' }}>
                    {/* @ts-ignore */}
                    <label htmlFor={"GroupContinuation" + this.props.ele.Sequence}>Group Continuation</label>
                </div>
                <div style={{ width: '60%' }}>
                    {/* @ts-ignore */}
                    <Checkbox value={this.props.ele.GroupContinuation} id={"GroupContinuation" + this.props.ele.Sequence} onChange={(e) => { this.props.ele.GroupContinuation = e.checked; this.props.callback() }} checked={this.props.ele.GroupContinuation} />
                </div>
            </div>
        </>
    );

    dateFormatHtml = () => (
        <>  
            <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                <div style={{ width: '25%' }}>
                    {/* @ts-ignore */}
                    <label htmlFor={"DateISOFormat" + this.props.ele.Sequence}>ISO format(YY-MM-DD)</label>
                </div>
                <div style={{ width: '60%' }}>
                    {/* @ts-ignore */}
                    <Checkbox value={this.props.ele.DateISOFormat} id={"DateISOFormat" + this.props.ele.Sequence} onChange={(e) => { this.props.ele.DateISOFormat = e.checked; this.props.callback() }} checked={this.props.ele.DateISOFormat} />
                </div>
            </div> 
        </>
    );

    toDisplayWhenEmptyHtml = () => (
        <>  
          {/* @ts-ignore */}   
                     
            <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }} key={"to_display_when_empty" + this.props.ele.Id}>
            
                <div style={{ width: '25%' }}>
                    {/* @ts-ignore */}                         
                    <label htmlFor={"toDisplayWhenEmpty" + this.props.ele.Sequence}>To display when empty</label>                      
                </div>
               
                <div>
                    {/* @ts-ignore */}
                    <InputText id={"toDisplayWhenEmpty" + this.props.ele.Sequence} className="ontario-input" value={this.props.isEng? this.props.ele.ToDisplayWhenEmpty : this.props.ele.ToDisplayWhenEmptyFRA}
                        onChange={(e) => {
                            {/* @ts-ignore */}
                            if(this.props.isEng){
                            {/* @ts-ignore */}
                            this.props.ele.ToDisplayWhenEmpty = e.target.value;
                            }else{
                            {/* @ts-ignore */}
                            this.props.ele.ToDisplayWhenEmptyFRA = e.target.value;
                            }
                            {/* @ts-ignore */}
                            this.props.callback();
                        }}
                    />
                </div> 
         </div>   
        </>
    );

    apiConfigsHtml = () => {
        {/* @ts-ignore */}
        const sectionIndex = generateSectionIndex(this.props.ele);

        return (
            <>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Enable Recaptcha</div>
                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                        {/* @ts-ignore */}
                        <Checkbox checked={!!this.props.ele.Recaptcha || this.props.ele.SubmitButton?.enableRecaptcha} value={!!this.props.ele.Recaptcha}
                            className='p-checkbox' title="Enable Recaptcha"
                            onChange={(e) => {
                            {/* @ts-ignore */}
                                this.props.ele.Recaptcha = e.checked ? {action: ''} : undefined;
                            {/* @ts-ignore */}
                                this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, enableRecaptcha: e.checked ? e.checked : false };
                            {/* @ts-ignore */}
                                this.props.callback();
                            }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>API</div>
                    <div style={{ width: '60%'}}>
                        {/* @ts-ignore */}
                        <InputText className="ontario-input" value={this.props.ele.Api || this.props.ele.SubmitButton?.api}
                            onChange={(e)=> { 
                                {/* @ts-ignore */}
                                this.props.ele.Api = e.target.value;
                                {/* @ts-ignore */}
                                this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, api: e.target.value };
                                {/* @ts-ignore */}
                                this.props.callback();
                            }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>API-Key</div>
                    <div style={{ width: '35%'}}>
                        {/* @ts-ignore */}
                        <InputText className="ontario-input"value={this.props.ele.ApiKeyKey || this.props.ele.SubmitButton?.apiKeyKey}
                            placeholder="Key" title="API-Key Key"
                            onChange={(e) => { 
                            {/* @ts-ignore */}
                                this.props.ele.ApiKeyKey = e.target.value; 
                            {/* @ts-ignore */}
                                this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, apiKeyKey: e.target.value }; 
                            {/* @ts-ignore */}
                                this.props.callback(); 
                            }} />
                    </div>
                    <div style={{ width: '35%'}}>
                        {/* @ts-ignore */}
                        <InputText className="ontario-input" value={this.props.ele.ApiKeyValue || this.props.ele.SubmitButton?.apiKeyValue} 
                            placeholder="Value" title="API-Key Value"
                            onChange={(e)=> { 
                            {/* @ts-ignore */}
                                this.props.ele.ApiKeyValue = e.target.value; 
                            {/* @ts-ignore */}
                                this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, apiKeyValue: e.target.value }; 
                            {/* @ts-ignore */}
                                this.props.callback(); 
                            }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Method</div>
                    <div style={{ width: '60%', marginTop: '5px' }}>
                        {/* @ts-ignore */}
                        <Dropdown style={{ width: '100%' }} showClear className="ontario-dropdown-small" options={SubmissionMethodList} value={this.props.ele.SubmissionMethod || this.props.ele.SubmitButton?.SubmissionMethod} optionLabel='label' optionValue='val' placeholder="SubmissionMethod"
                            onChange={(e) => { 
                            {/* @ts-ignore */}
                                this.props.ele.SubmissionMethod = e.value; this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, SubmissionMethod: e.value }; this.props.callback(); 
                            }} />
                    </div>
                </div>

                {/* @ts-ignore */}
                { (this.props.ele.Api || this.props.ele.SubmitButton?.api) && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>API error redirect to:</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            {/* @ts-ignore */}
                            <Dropdown style={{ width: '100%' }} showClear value={this.props.ele.SubmitButton?.apiErrorRedirectPage}
                                className="ontario-dropdown-small" options={sectionIndex} 
                                optionLabel='title' optionValue='sequence' placeholder="Page to redirect to"
                                onChange={(e) => {
                                    const sequence = Number(e.value);
                                    {/* @ts-ignore */}
                                    this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, apiErrorRedirectPage: isNaN(sequence) ? undefined : sequence};
                                    {/* @ts-ignore */}
                                    this.props.callback();
                                }}/>
                        </div>
                    </div>
                )}
            </>
        )
    }

     renderFooter = (props) => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { props.callback(false) }} />
            </div>
        );
    }
}
